<template>
  <div class="text-center py-5">
    <div class="img" v-if="image">
      <img class="img-fluid" :src="image" />
    </div>
    <div class="my-4 mx-auto">
      <h4>{{ heading }}</h4>
      <span class="lead text-muted font-weigh-bold">
        <slot>
          No referrals in your referrals list, yet!<br />
          Create your first referral right now.
        </slot>
      </span>
    </div>
    <router-link :to="link" class="btn btn-primary btn-lg btn-xl" v-if="cta">{{
      cta
    }}</router-link>
    <slot name="below">
    </slot>
  </div>
</template>
<script>
export default {
  props: {
    heading: {
      type: String,
      default: 'Start by creating a referral',
    },
    cta: {
      type: [String, Boolean],
      default: 'Create Referral',
    },
    link: {
      type: String,
      default: '/referral/create',
    },
    image: {
      type: String,
      default: require('../../assets/svg/no-referrals.svg'),
    },
  },
}
</script>

<style scoped>
</style>
